import {onBlockLoaded} from "@plaudit/frontend-apis";

onBlockLoaded({
	blockOrClassName: "plaudit-theme/product-range",
	onAdd(blockRoot) {
		if (!blockRoot.querySelector("table")) {
			return;
		}
		const messagesArea = blockRoot.querySelector<HTMLDivElement>(".messages-area")!;
		// blockRoot is the root element of the block (aka the element that has the wp-block-plaudit-theme/product-range class on it)
		// You can add any logic that needs to run once per block here
		blockRoot.addEventListener('click', async e => {
			if (e.target instanceof HTMLAnchorElement && e.target.classList.contains("add-to-cart")) {
				e.preventDefault();
				e.stopPropagation();
				const form = e.target.closest("form");
				if (!form) {
					return;
				}

				const idElement = form.elements.namedItem("variation_id") ?? form.elements.namedItem("product_id");
				let productIds: string[];
				if (idElement instanceof RadioNodeList) {
					productIds = [...idElement.values()].filter(element => element.checked).map(element => element.value);
				} else if (idElement instanceof HTMLInputElement) {
					productIds = [idElement.value];
				} else {
					return;
				}

				let success = true;
				const baseHref = e.target.href;
				for (const productId of productIds) {
					if ((await fetch(baseHref.replaceAll("__FROM_FORM__", productId), {method: 'GET'})).status >= 400) {
						success = false;
					}
				}

				if (success) {
					for (const input of form.querySelectorAll<HTMLInputElement>("[name='product_id'],[name='variation_id']")) {
						input.checked = false;
					}
					window.location.reload();
				} else {
					messagesArea.dispatchEvent(new CustomEvent("msa/plaudit-custom-theme/updated-quote-or-cart", {detail: {success, message: "Failed to add product(s) to cart"}}));
				}
			}
		});

		document.addEventListener("msa/region-locked-products/quote-update", () => {
			for (const input of blockRoot.querySelectorAll<HTMLInputElement>("[name='product_id'],[name='variation_id']")) {
				input.checked = false;
			}
		});

		messagesArea.addEventListener("msa/plaudit-custom-theme/updated-quote-or-cart", e => {
			const {detail: {success, message}} = e as CustomEvent<{success: boolean, message: string}>;
			const messageElement = document.createElement("div");
			messageElement.classList.add("notice", success ? "success" : "failure");
			messageElement.innerHTML = `<span class="message-text">${message}</span><button class="close-button" type="button">Close</button>`;
			messageElement.querySelector(".close-button")?.addEventListener("click", e => {
				e.preventDefault();
				e.stopPropagation();
				messageElement.remove();
			});
			messagesArea.appendChild(messageElement);
		});
	}
	// If you need to add logic that runs once per removal, add onRemove(blockRoot) {} to this object
});
